import React, { useEffect, useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import CustomButton from "../../../common/CustomButton";
import { DeleteIcon, EditIcon } from "../../../../assets/svg/svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { deleteProduct, getApi } from "../../../../actions/structure.action";
import { tableStructures } from "../../../../helpers/table-structures";
import Spinner from "../../../common/Spinner";
import ProductCrud from "../../common/ProductCrud";
import CustomTable from "../../common/CustomTable";
import { appConstants, stringConstants } from "../../../../helpers";
import isEmpty from "../../../../utils/is-Empty";
import { useDialog } from "../../../../helpers/useDialog";
import { Link } from "react-router-dom";

const Products = () => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [sellerProductsArray, setSellerProductsArray] = useState([]);
  const [showProductCreateMode, setShowProductCreateMode] = useState(false);
  const [selectedFormObj, setSelectedFormObj] = useState({});
  const [showAddProduct, setShowAddProduct] = useState(false);

  const { products, brands, userSubscriptionInfo, auth } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getBrands", dispatch);
    getApi("getProducts", dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (products?.data?.length < 1) {
      setShowProductCreateMode(true);
    } else {
      setShowProductCreateMode(false);
    }
    if (products?.data?.length > 0) {
      const filtered = products?.data.filter((item) => item.status); // Replace with your desired filter condition
      // Sort descending (latest first)
      const sortedDesc = [...filtered].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setSellerProductsArray(sortedDesc);
    }
  }, [products]);

  useEffect(() => {
    if (auth?.user?.role?.role_name === stringConstants.ROLL_SELLER) {
      if (userSubscriptionInfo && !isEmpty(userSubscriptionInfo?.data)) {
        const productUpload =
          userSubscriptionInfo?.data?.subscriptionFeatures?.productUpload ||
          userSubscriptionInfo?.data?.sellerInfo?.subscriptionFeatures?.productUpload;
        if (sellerProductsArray && sellerProductsArray.length >= productUpload) {
          setShowAddProduct(false);
        } else {
          setShowAddProduct(true);
        }
      }
    }
  }, [userSubscriptionInfo, auth, sellerProductsArray]);

  const clickToSubscribe = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          dispatch({
            type: stringConstants.SET_CURRENT_VIEW,
            payload: stringConstants.MY_SUBSCRIPTIONS,
          });
        }}
      >
        upgrade
      </Link>
    );
  };

  return (
    <Container className="slller-products p-0">
      {DialogModal}
      {products.loading ? (
        <Container className="seller-product-create-form  p-0 ">
          <Spinner />
        </Container>
      ) : brands.data?.length < 1 ? (
        <Container>
          <p>{"No brand is available for product creation."}</p>
        </Container>
      ) : !showProductCreateMode && sellerProductsArray?.length > 0 ? (
        <Row className="m-0 mb-2">
          {!showAddProduct && (
            <Col md={12}>
              <Alert variant="danger" className="mb-0 mt-2">
                <ul className="m-0 p-0 list-unstyled">
                  <li key={"index-01"} className="d-flex align-items-start">
                    <span className="me-2 text-danger">✔</span>
                    <span>
                      You have reached the maximum limit of allowed products to add. Please{" "}
                      {clickToSubscribe()} your subscription.
                    </span>
                  </li>
                </ul>
              </Alert>
            </Col>
          )}
          <CustomTable
            columns={tableStructures.product}
            data={sellerProductsArray}
            enableRowActions
            positionActionsColumn={"last"}
            enableTopToolbar={true}
            emptyTableMsg={""}
            enablePagination={true}
            // enableFilters={false} // remove filter icons
            enableColumnActions={false} // remove column action
            enableFullScreenToggle={false} // emove full screen option
            // enablePagination={false} //disable a default feature
            // enableHiding={false} // show hid colmuns action
            renderRowActions={({ row, table }) => (
              <div className="table-action-box">
                <CustomButton
                  buttonClasses="icon-action-btn"
                  onClick={() => {
                    setShowProductCreateMode(true);
                    setSelectedFormObj(row.original);
                  }}
                >
                  <EditIcon />
                </CustomButton>
                <CustomButton
                  buttonClasses="icon-action-btn"
                  onClick={() => deleteProduct(row.original.id, dispatch, confirm)}
                >
                  <DeleteIcon />
                </CustomButton>
              </div>
            )}
            renderTopToolbarCustomActions={({ table }) => (
              <div className="table-heading-wrap">
                <h4>{"Your products"}</h4>

                {showAddProduct && (
                  <CustomButton
                    buttonClasses="icon-add-btn"
                    onClick={() => {
                      setShowProductCreateMode(true);
                      setSelectedFormObj({});
                    }}
                  >
                    {"Add"}
                  </CustomButton>
                )}
              </div>
            )}
            initialState={{
              columnPinning: {
                right: ["mrt-row-actions"],
              },
            }}
            //   enableColumnOrdering={false} //enable some features
            //   enableRowSelection={false}
            //   enableColumnResizing={false}
            //   onRowSelectionChange={setRowSelection} //hoist internal state to your own state (optional)
            //   state={{ rowSelection }} //manage your own state, pass it back to the table (optional)
            //   tableInstanceRef={tableInstanceRef} //get a reference to the underlying table instance (optional)
          />
        </Row>
      ) : (
        <Container className="seller-product-create-form p-0">
          <ProductCrud
            product={selectedFormObj}
            setShowProductCreateMode={setShowProductCreateMode}
            listEmpty={sellerProductsArray?.length > 0 ? false : true}
          />
        </Container>
      )}
    </Container>
  );
};

export default Products;
